import permission from './permission'
import tooltip from './tip'
import loadmore from './loadmore'
import Vue from 'vue'
Vue.directive('tooltip', tooltip)
Vue.directive('permission', permission)
Vue.directive('loadmore', loadmore)
// Vue.use(permission)
